import { render, staticRenderFns } from "./terms_and_conditions.vue?vue&type=template&id=51020026&scoped=true&"
import script from "./terms_and_conditions.vue?vue&type=script&lang=js&"
export * from "./terms_and_conditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51020026",
  null
  
)

export default component.exports